// import React, { useState } from 'react'
// import Coupon from './Coupon';
// import OrderView from '../components/OrderView';
// import OrderConfirmation from '../components/OrderConfirmation';
// import OfflineOrderEntry from '../components/OfflineOrderEntry';
// import QrCodeGenerator from '../components/QrCodeGenerator';

// const Order = () => {
//      const [activeTab, setActiveTab] = useState('view-orders');
    
//     const renderContent = () => {
//         switch (activeTab) {
//             case 'view-orders':
//                 return <OrderView  />;
//             case 'shipment':
//                 return <OrderConfirmation />;
//             case 'order-create':
//                 return <OfflineOrderEntry />;
//             case 'qrcode' :
//                 return <QrCodeGenerator value={'https://www.kanthasri.com'}/>
//             default:
//                 return <Coupon />;
//         }
//     };
//   return (
//    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 p-2 lg:p-4">
//             <div className="max-w-7xl mx-auto">
//                 <div className="border-b border-gray-200 mb-6 flex justify-start gap-4">
//                     <button
//                         onClick={() => setActiveTab('view-orders')}
//                         className={`py-2 px-4 transition-colors duration-200 ${
//                             activeTab === 'view-orders'
//                                 ? 'border-b-2 border-blue-600 text-blue-600 font-semibold'
//                                 : 'text-gray-500 hover:text-gray-700'
//                         }`}
//                     >
//                         View Orders
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('shipment')}
//                         className={`py-2 px-4 transition-colors duration-200 ${
//                             activeTab === 'shipment'
//                                 ? 'border-b-2 border-blue-600 text-blue-600 font-semibold'
//                                 : 'text-gray-500 hover:text-gray-700'
//                         }`}
//                     >
//                         Shipment
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('order-create')}
//                         className={`py-2 px-4 transition-colors duration-200 ${
//                             activeTab === 'order-create'
//                                 ? 'border-b-2 border-blue-600 text-blue-600 font-semibold'
//                                 : 'text-gray-500 hover:text-gray-700'
//                         }`}
//                     >
//                         Offline Order
//                     </button>
//                     <button
//                         onClick={() => setActiveTab('qrcode')}
//                         className={`py-2 px-4 transition-colors duration-200 ${
//                             activeTab === 'qrcode'
//                                 ? 'border-b-2 border-blue-600 text-blue-600 font-semibold'
//                                 : 'text-gray-500 hover:text-gray-700'
//                         }`}
//                     >
//                         qrcode
//                     </button>
//                 </div>
//                 {renderContent()}
//             </div>
//         </div>
//   )
// }

// export default Order

import React, { useState } from 'react';
import { FaListUl, FaTruck, FaPlusCircle, FaQrcode, FaTicketAlt } from 'react-icons/fa';
import Coupon from './Coupon';
import OrderView from '../components/OrderView';
import OrderConfirmation from '../components/OrderConfirmation';
import OfflineOrderEntry from '../components/OfflineOrderEntry';
import QrCodeGenerator from '../components/QrCodeGenerator';

const Order = () => {
    const [activeTab, setActiveTab] = useState('view-orders');

    const tabs = [
        { id: 'view-orders', label: 'View Orders', icon: <FaListUl /> },
        { id: 'shipment', label: 'Shipment', icon: <FaTruck /> },
        { id: 'order-create', label: 'Offline Order', icon: <FaPlusCircle /> },
        { id: 'qrcode', label: 'QR Code', icon: <FaQrcode /> },
        { id: 'coupons', label: 'Coupons', icon: <FaTicketAlt /> },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'view-orders': return <OrderView />;
            case 'shipment': return <OrderConfirmation />;
            case 'order-create': return <OfflineOrderEntry />;
            case 'qrcode': return <QrCodeGenerator value={'https://www.kanthasri.com'} />;
            default: return <Coupon />;
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
            {/* Header Section */}
            <div className="bg-white border-b border-slate-200 pt-6 px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-serif italic text-slate-900">Order Management</h1>
                        <p className="text-[10px] uppercase tracking-[0.3em] text-slate-400 font-bold mt-1">
                            Artisanal Inventory & Logistics
                        </p>
                    </div>

                    {/* Navigation Tabs */}
                    <div className="flex overflow-x-auto no-scrollbar scroll-smooth gap-1 md:gap-8 border-b border-transparent">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-2 py-3 px-2 md:px-1 whitespace-nowrap transition-all duration-300 border-b-2 text-xs md:text-sm font-bold uppercase tracking-widest ${
                                    activeTab === tab.id
                                        ? 'border-slate-900 text-slate-900'
                                        : 'border-transparent text-slate-400 hover:text-slate-600'
                                }`}
                            >
                                <span className={activeTab === tab.id ? 'text-amber-600' : ''}>
                                    {tab.icon}
                                </span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <main className="max-w-7xl mx-auto p-4 md:p-8 animate-fadeIn">
                <div className="bg-white rounded-sm shadow-sm border border-slate-100 min-h-[60vh]">
                    {renderContent()}
                </div>
            </main>

            {/* CSS for hiding scrollbar but keeping functionality */}
            <style dangerouslySetInnerHTML={{ __html: `
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
            `}} />
        </div>
    );
};

export default Order;